import { lazyComponent } from "../../shared/lazy.js";

/** Le panneau Contenu des réglages (Studio), chargé à la demande ; l'app le précharge avec l'écran Moi. */
export const ContentSettings = lazyComponent(() => import("../studio/Content.js"), "ContentSettings");
export const loadContentSettings = ContentSettings.load;
